import { render, staticRenderFns } from "./RegistrationTariffStep.vue?vue&type=template&id=d7220d0c&"
import script from "./RegistrationTariffStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationTariffStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports